type GenPathSuffixOptions = { experimentName: string; variantName: string; currentUserId: string };

type GenPathSuffix = (data: GenPathSuffixOptions) => string;

const GENERATORS: Readonly<Record<'facebook' | 'whatsapp' | 'copy', GenPathSuffix>> = {
	facebook: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/nftexp/${experimentName}/${variantName}/${currentUserId}`,
	copy: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/cl_/${experimentName}/${variantName}/${currentUserId}`,
	whatsapp: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/wa/${experimentName}/${variantName}/${currentUserId}`,
};

export function getPathSuffixGenerator(channel: 'facebook' | 'whatsapp' | 'copy'): GenPathSuffix {
	return GENERATORS[channel];
}
